import { AuctionType } from '#/unified-rfqs/entities/shared';
import { PRODUCTS } from '#/products/config';
import { isProductDisabledForType } from '#/products/types';

export interface AuctionOption {
  readonly value: AuctionType;
  readonly label: string;
  readonly submitText: string;
  readonly disabled?: boolean;
  readonly disabledTooltip?: string;
}

export interface AuctionView {
  readonly options: readonly AuctionOption[];
  readonly selectedOption: AuctionOption;
}

const OB_OPTION: AuctionOption = {
  value: 'OB',
  label: 'Order Book (OB)',
  submitText: 'Create OB',
};

const RFQ_OPTION: AuctionOption = {
  value: 'RFQ',
  label: 'RFQ',
  submitText: 'Send RFQ',
};

const OPTIONS: readonly AuctionOption[] = [RFQ_OPTION, OB_OPTION];

export default function auctionView(
  auction: string | null,
  productCode: string | null = null,
): AuctionView {
  const isObDisabled =
    productCode != null &&
    PRODUCTS[productCode] != null &&
    isProductDisabledForType(PRODUCTS[productCode]!, 'OB');

  const options: readonly AuctionOption[] = OPTIONS.map((opt) =>
    opt.value === 'OB' && isObDisabled
      ? { ...opt, disabled: true, disabledTooltip: 'Coming Soon' }
      : opt,
  );

  const selectedOption =
    options.find((opt) => opt.value === auction && opt.disabled !== true) ??
    RFQ_OPTION;

  return { options, selectedOption };
}
